import Head from 'next/head';

import { useCommonData } from '@app/hooks/useCommonData';
import { useHeadMeta } from '@app/hooks/useHeadMeta';

interface CommonHeadProps {
  title?: string;
  description?: string;
  keywords?: string[];
  ogImage?: string;
}

export const CommonHead: React.FC<CommonHeadProps> = props => {
  const { website } = useCommonData();
  const {
    title: ctxTitle,
    description: ctxDesc,
    keywords: ctxKeywords,
    ogImage: ctxOg,
  } = useHeadMeta();
  const title =
    (ctxTitle && `${ctxTitle} | ${website.fullName}`) ?? props.title ?? website.fullName ?? '';
  const description = ctxDesc ?? props.description ?? website.description ?? '';
  const keywords = ctxKeywords ?? props.keywords ?? website.seo.keywords ?? [];
  const ogImage = ctxOg ?? props.ogImage ?? website.seo.ogImage ?? '';

  return (
    <Head>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={[...keywords].join(',')} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="manifest" href="/manifest.json" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black" />
      <meta name="apple-mobile-web-app-title" content={title} />
      <meta name="format-detection" content="telephone=no" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="theme-color" content="#000000" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={website.author.name ?? ''} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:site" content={process.env.NEXT_PUBLIC_TWITTER_USERNAME ?? ''} />
      <meta name="twitter:url" content={process.env.NEXT_PUBLIC_APP_URL ?? ''} />
    </Head>
  );
};
